<template>
  <div class="home">
    <!-- hero ヒーロー -->
    <div id="hero" class="container-flued hero">
      <img src="../assets/image/common/blue1240x220.png" />
    </div><!-- hero ヒーロー -->
    <!-- 表示形式 表示順 -->
    <div class="ly_container">
      <br>
      <br>
      <h6><span class="txt_highlight">洋服のサイズ シミュレーション</span></h6>
      <h1><span class="txt_highlight">サイズミル</span></h1>
      <h6 class="txt_gray">by kitemiru</h6>
      <br>
      <br>
      <h5>洋服のサイズ選びに関する不安を解消！</h5>
      <h5>すべての洋服を自分の身長で試着してみて、欲しいサイズの洋服が選べます！</h5>
      <br>
      <br>
      <br>
      <h4>商品一覧ページ サンプル</h4>
      <div class="underline"></div>
      <br>
      <!-- 表示形式を選択 -->
      <ul class="show_tabs">
        <li
          @click="showChange('1')"
          v-bind:class="{'show-active': showActive === '1'}">
          商品+試着
        </li>
        <li
          @click="showChange('2')"
          v-bind:class="{'show-active': showActive === '2'}">
          商品画像
        </li>
        <li
          @click="showChange('3')"
          v-bind:class="{'show-active': showActive === '3'}">
          試着画像
        </li>
      </ul>
      <!-- 表示順を選択 -->
      <div class="sort_box">
        <div class="sort_txt">
          <span v-on:click="sortBy('id')" v-bind:class="sortedClass('id')">新着順</span>
        </div>
        <div class="sort_txt">
          <span v-on:click="sortBy('price')" v-bind:class="sortedClass('price')">価格順</span>
        </div>
        <div class="sort_txt">
          <span v-on:click="sortBy('length')" v-bind:class="sortedClass('length')">着丈順</span>
        </div>
      </div>
    </div>
    <!-- メイン -->
    <div class="ly_cont">
      <!-- サイドバー -->
      <div class="ly_cont_side">
        <!-- 身長の選択 -->
        <div class="ly_cont_side_box">
          <h6><span class="txt_highlight">身長を選んで下さい</span></h6>
          <!-- 左ボックス 身長変更 -->
          <div class="bl_dressbox">
            <div class="bl_dressroom_1">
              <!-- マネキン -->
              <ul class="image-box">                
                <li class="image-item">
                  <img v-bind:style="{
                    transform: 'scale(' + bodyHeight/baseHeight + ',' +  bodyHeight/baseHeight + ')',
                    marginTop: marginFloor * (1 - bodyHeight/baseHeight) * sizeRatioSide + 36 + 'px'
                  }"
                  src="../assets/image/common/w_o_l.png">
                </li>
                <li class="image-item">
                  <img v-bind:style="{
                    transform: 'scale(' + bodyHeight/baseHeight + ',' +  bodyHeight/baseHeight + ')',
                    marginTop: marginFloor * (1 - bodyHeight/baseHeight) * sizeRatioSide + 36 + 'px'
                  }"
                  :src=lengths[lengthActive].dressImage>
                </li>
              </ul>
            </div>
            <!-- メジャー -->
            <div class="measure_left">
              <img v-bind:style="{
                position: 'absolute',
                marginLeft: '-12px',
                stansform: 'scale(1,1)',
                marginTop: ((240 - marginShoulder) * (1 - bodyHeight/baseHeight) * sizeRatioSide) + 36 +'px',
                }"
                src="../assets/image/common/measure_left.png">
              <img v-bind:style="{
                position: 'absolute',
                marginLeft: '-12px',
                stansform: 'scale(1,1)',
                marginTop: 36 +'px',
                }"
                src="../assets/image/common/measure_left_cover.png">
            </div>
            <div class="measure_right">
              <img v-bind:style="{
                position: 'absolute',
                marginLeft: '-17px',
                stansform: 'scale(1,1)',
                marginTop: ((marginFloor - marginHead) * (1 - bodyHeight/baseHeight) * sizeRatioSide) + 36 +'px',
                }"
                src="../assets/image/common/measure-right.png">              
              <img v-bind:style="{
                position: 'absolute',
                marginLeft: '-17px',
                stansform: 'scale(1,1)',
                marginTop: 36 +'px',
                }"
                src="../assets/image/common/measure_right_cover.png">
            </div>
          </div>
        <!-- 身長選択スライダー -->
          <div class="bl_header_slider">
            <vue-slider
              v-model="bodyHeight" :min="144" :max="176" 
                @drag-start="slideStart"
                @drag-end="slideStop"/>
            <!-- <b-form-slider 
              class="slider"
              style="slider"
              v-model="bodyHeight" :min="144" :max="176" trigger-change-event 
              @slide-start="slideStart"
              @slide-stop="slideStop">
            </b-form-slider> -->
          </div>
          <div class="slider_txt">
            身長&emsp;：&emsp;{{ bodyHeight }}&nbsp;cm
          </div>
        </div>

        <div class="ly_cont_side_box">
          <h6>裾の位置を選んで下さい</h6>
          <ul class="length_tabs">
            <li
              v-for="(length, index) in lengths"
              v-bind:key="length.id"
              v-bind:class="{'active': index === lengthActive}"
              v-on:click="changeLength(index)">
              {{ length.name}}
              </li>
          </ul>
        </div>

        <!-- 服の種類を選択 -->
        <div class="ly_cont_side_box">
          <h6>服の種類を選んで下さい</h6>
          <ul class="category_tabs">
            <li
              v-for="(category, index) in categories"
              v-bind:key="category.categoryId"
              v-bind:class="{'category_active': index === categoryActive}"
              v-on:click="changeCategory(index)">
              <img :src=category.categoryImage alt="">
            </li>
          </ul>
        </div>

        <!-- カラーを選択 -->
        <div class="ly_cont_side_box">
          <h6>カラーを選んで下さい</h6>
          <ul class="color_tabs">
            <li
              v-for="(color, index) in colors"
              v-bind:key="color.id"
              v-bind:class="{'color_active': index === colorActive}"
              v-on:click="changeColor(index)">
              <img :src=color.colorImage alt="">
            </li>
          </ul>
        </div>

      </div>

      <!-- 商品リスト -->
      <div class="ly_cont_main">
        <ul class="ly_cont_main_inner">

          <!-- 商品カード -->
          <li v-for="item in eventedAction" v-bind:key="item.id">
            <!-- （１）商品・試着画像カード -->
            <div v-if="showActive === '1'" class="bl_card">
              <!-- 商品画像 -->
              <div class="bl_card_top">
                <div class="bl_card_img">
                  <img class="thumbImage" :src=item.thumbImage>
                </div>
              <!-- 試着画像 -->
                <div class="bl_dressroom">
                  <ul class="image-box">                
                    <!-- マネキン -->
                    <li class="image-item">
                      <img v-bind:style="{
                        transform: 'scale(' + bodyHeight/baseHeight + ',' +  bodyHeight/baseHeight + ')',
                        marginTop: marginFloor * (1 - bodyHeight/baseHeight) * sizeRatioCard + 'px'
                      }"
                      src="../assets/image/common/t_base_line.png">
                    </li>
                    <!-- ワンピース -->
                    <li class="image-item">
                      <img v-bind:style="{
                        transform: 'scale(' + bodyHeight/baseHeight + ',1)', 
                        marginTop: (marginFloor - item.baseLine) * (1 - bodyHeight / 160) * sizeRatioCard + 'px'
                      }"
                      class="thumbImage" :src=item.dressImage>
                    </li>
                  </ul>
                </div>

              </div>
              <!-- 商品テキスト -->
              <div class="bl_card_text">
                <p>{{ item.name }}</p>
                <p>{{ item.brand }}</p>
                <p>{{ item.shop }}</p>
                <p>{{ item.price | addComma }} 円</p>
                <p v-if="item.length != 0">肩下 {{ item.length }} cm</p>
              </div>
            </div>
            <!-- （２）商品画像カード -->
            <div v-if="showActive === '2'" class="bl_card_2">
              <!-- （２−１）商品詳細カード -->
              <div class="bl_card_2_1">
                <!-- 商品画像 -->
                <div class="bl_card_img_2">
                  <img class="thumbImage" :src=item.thumbImage>
                </div>
                <!-- 商品テキスト -->
                <div class="bl_card_text_2">
                  <p>{{ item.name }}</p>
                  <p>{{ item.brand }}</p>
                  <p>{{ item.shop }}</p>
                  <p>肩下 {{ item.length }} cm</p>
                  <p>{{ item.price | addComma }} 円</p>
                </div>
              </div>
              <!-- （２−２）試着画像カード -->
              <div class="bl_card_2_1">
                <!-- 試着画像 -->
                <div class="bl_dressroom_3">
                  <ul class="image-box">
                    <!-- マネキン -->
                    <li class="image-item">
                      <img v-bind:style="{
                        transform: 'scale(' + bodyHeight/baseHeight + ',' +  bodyHeight/baseHeight + ')',
                        marginTop: marginFloor * (1 - bodyHeight/baseHeight) * sizeRatioCard2 + 'px'
                      }"
                      src="../assets/image/common/t_base_line.png">
                    </li>
                    <!-- ワンピース -->
                    <li class="image-item">
                      <img v-bind:style="{
                        transform: 'scale(' + bodyHeight/baseHeight + ',1)', 
                        marginTop: (marginFloor - item.baseLine) * (1 - bodyHeight / 160) * sizeRatioCard2 + 'px'
                      }"
                      class="thumbImage" :src=item.dressImage>
                    </li>
                  </ul>
                  <div class="bl_card_text_3">
                    <p>{{ item.brand }}</p>
                    <p>肩下 {{ item.length }} cm</p>
                  </div>
                </div>
              </div>
            </div>
            <!-- （３）試着画像カード -->
            <div v-if="showActive === '3'" class="bl_card_2">
              <!-- （３−１）商品詳細カード -->
              <div class="bl_card_2_1">
                <!-- 試着画像 -->
                <div class="bl_dressroom_3">
                  <ul class="image-box">                
                    <!-- マネキン -->
                    <li class="image-item">
                      <img v-bind:style="{
                        transform: 'scale(' + bodyHeight/baseHeight + ',' +  bodyHeight/baseHeight + ')',
                        marginTop: marginFloor * (1 - bodyHeight/baseHeight) * sizeRatioCard2 + 'px'
                      }"
                      src="../assets/image/common/t_base_line.png">
                    </li>
                    <!-- ワンピース -->
                    <li class="image-item">
                      <img v-bind:style="{
                        transform: 'scale(' + bodyHeight/baseHeight + ',1)', 
                        marginTop: (marginFloor - item.baseLine) * (1 - bodyHeight / 160) * sizeRatioCard2 + 'px'
                      }"
                      class="thumbImage" :src=item.dressImage>
                    </li>
                  </ul>
                  <div class="bl_card_text_3">
                    <p>{{ item.brand }}</p>
                    <p>肩下 {{ item.length }} cm</p>
                  </div>
                </div>
              </div>
              <!-- （３−２）試着画像カード -->
              <div class="bl_card_2_1">

                <!-- 商品画像 -->
                <div class="bl_card_img_2">
                  <img class="thumbImage" :src=item.thumbImage>
                </div>
                <!-- 商品テキスト -->
                <div class="bl_card_text_2">
                  <p>{{ item.name }}</p>
                  <p>{{ item.brand }}</p>
                  <p>{{ item.shop }}</p>
                  <p>肩下 {{ item.length }} cm</p>
                  <p>{{ item.price | addComma }} 円</p>
                </div>
              </div>

            </div>
          </li>
        </ul>
      </div>

    </div>

    <!-- 商品詳細ヒーロー -->
    <div class="ly_container">
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <h4>サイズ詳細ページ サンプル</h4>
      <div class="underline"></div>
      <br>
      <br>
      <br>
    </div>

    <!-- 商品詳細ページ -->
    <div class="ly_container">
      <div class="bl_detail">

        <!-- 詳細　試着室 -->
        <div class="bl_detail_dressroom">

          <div class="detail_center">
            <div class="detail_dressroom">

              <ul class="image-box">                
                <!-- マネキン -->
                <li class="image-item">
                  <img v-bind:style="{
                    transform: 'scale(' + bodyHeight/baseHeight * bodyWaistRatio / 100 + ',' +  bodyHeight/baseHeight + ')',
                    marginTop: marginFloor * (1 - bodyHeight/baseHeight) * sizeRatioDetail + 36 + 'px'
                  }"
                  :src=mannequinTypes[detailModelActive].bodyImage>
                </li>

                <!-- シューズ -->
                <li class="image-item">
                  <img v-bind:style="{
                    transform: 'scale(' + bodyHeight/baseHeight * bodyWaistRatio / 100 + ',' + bodyHeight/baseHeight + ')',
                    marginTop: marginShoes * (1 - bodyHeight/baseHeight) * sizeRatioDetail + 36 + 'px'
                  }"
                  :src=shoesTypes[detailShoesActive].dressImage>
                </li>

                <!-- ワンピース -->
                <li class="image-item">
                  <img v-bind:style="{
                    transform: 'scale(' + bodyHeight/baseHeight * bodyWaistRatio / 100 + ',' + ((itemSizes[detailSizeActive]).sizeShoulder) / ((itemSizes[sizeBase]).sizeShoulder) + ')',
                    marginTop: ((marginFloor - marginShoulder)  * (1 - bodyHeight/baseHeight) + (marginShoulder * (1 - ((itemSizes[detailSizeActive]).sizeShoulder) / ((itemSizes[sizeBase]).sizeShoulder))))*  sizeRatioDetail + 36 + 'px'
                  }"
                  :src=itemColors[detailColorActive].dressImage>
                </li>
              </ul>
            </div>

          </div>
          <div class="detail_left">
            <div class="measure-wrap">
              <img v-bind:style="{
                transform: 'scaleY(' + bodyHeight/baseHeight + ')',
                marginLeft: -148 + 'px',
                marginTop: marginFloor * sizeRatioDetail * (1 - bodyHeight/baseHeight) + 56 + 'px',
                }"
                src="../assets/image/common/measure-line.png">
            </div>
            <div class="measure-wrap">
              <img v-bind:style="{
                position: 'absolute',
                marginLeft: -100 + 'px',
                marginTop: ((marginFloor - marginShoulder) * (1 - bodyHeight/baseHeight) * sizeRatioDetail) + 131 +'px',
                }"
                src="../assets/image/common/measure_num.png">
            </div>
            <div class="measure-wrap">
              <img v-bind:style="{
                position: 'absolute',
                marginLeft: -100 + 'px',
                marginTop: 56 + 'px',
              }"
              src="../assets/image/common/measure_left_cover.png">
            </div>
          </div>

          <div class="detail_right">
            <div class="measure-wrap">
              <img v-bind:style="{
                transform: 'scaleY(' + bodyHeight/baseHeight + ')',
                marginTop: marginFloor * sizeRatioDetail * (1 - bodyHeight/baseHeight) + 56 + 'px',
                }"
                src="../assets/image/common/measure-line.png">
            </div>
            <div class="measure-wrap">
              <img v-bind:style="{
                position: 'absolute',
                marginLeft: 0 + 'px',
                marginTop: ((marginFloor - marginHead) * (1 - bodyHeight/baseHeight) * sizeRatioDetail) + 56 + 'px',
                }"
                src="../assets/image/common/measure_num.png">
            </div>
            <div class="measure-wrap">
              <img v-bind:style="{
                position: 'absolute',
                marginTop: 56 + 'px',
              }"
              src="../assets/image/common/measure_left_cover.png">
            </div>

          </div>


          <div class="detail_dressroom_slider">
            身長&emsp;：&emsp;{{ bodyHeight }}&nbsp;cm
          </div>

        </div>

        <!-- 詳細　選択ボタン -->
        <div class="bl_detail_buttons">

          <div class="bl_detail_panel">
            <h5>身長を選択してください</h5>
            <div class="detail_slider_txt">
              <h6>身長&emsp;：&emsp;{{ bodyHeight }}&nbsp;cm</h6>
            </div>
            <div class="bl_detail_slider">
              <vue-slider
                v-model="bodyHeight" :min="144" :max="176" 
                  @drag-start="slideStart"
                  @drag-end="slideStop"/>

              <!-- <b-form-slider 
                class="slider"
                style="slider"
                v-model="bodyHeight" :min="144" :max="176" trigger-change-event 
                @slide-start="slideStart"
                @slide-stop="slideStop">
              </b-form-slider> -->
            </div>
          </div>

          <div class="bl_detail_panel">
            <h5>洋服のカラーを選択してください</h5>
            <ul class="large-select-panel">
              <li
                v-for="(color, index) in itemColors" 
                v-bind:key="color.id"
                class="color-item"
                v-bind:class="{'color-active': index === detailColorActive}"
                v-on:click="changeDetailColor(index)">
                <img :src="color.thumbImage">
                <h5>{{ color.color }}</h5>
              </li>
            </ul>
          </div>

          <div class="bl_detail_panel">
            <h5>体型を選択してください</h5>          
            <div class="detail_slider_txt">
              <h6>B：{{ Math.round(bodyHeight * 0.52 * bodyWaistRatio / 100) }}&nbsp;cm&nbsp;/&nbsp;
                W：{{ Math.round(bodyHeight * 0.39 * bodyWaistRatio / 100) }}&nbsp;cm&nbsp;/&nbsp;
                H：{{ Math.round(bodyHeight * 0.53 * bodyWaistRatio / 100) }}&nbsp;cm</h6>
              
            </div>
            <div class="bl_detail_slider">
              <vue-slider
                v-model="bodyWaistRatio" :min="90" :max="110" 
                :tooltip="'none'"
                  @drag-start="slideStart"
                  @drag-end="slideStop"/>

              <!-- <b-form-slider 
                class="slider"
                style="slider"
                v-model="bodyWaistRatio" :min="90" :max="110" trigger-change-event 
                @slide-start="w_slideStart"
                @slide-stop="w_slideStop">
              </b-form-slider> -->
            </div>
          </div>

          <div class="bl_detail_panel">
            <h5>洋服のサイズを選択してください</h5>
            <ul class="large-select-panel">
              <li
                v-for="(size, index) in itemSizes" 
                v-bind:key="size.id"
                class="size-item"
                v-bind:class="{'size-active': index === detailSizeActive}"
                v-on:click="changeDetailSize(index)">
                <img src="../assets/image/common/sizeback.jpg">
                <p>{{ size.sizeText }}</p>
              </li>
            </ul>
          </div>

          <div class="bl_detail_panel">
            <h5>モデルを選択してください</h5>
            <ul class="large-select-panel">
              <li
                v-for="(mannequin, index) in mannequinTypes"
                v-bind:key="mannequin.id"
                class="mannequin-item"
                v-bind:class="{'mannequin-active': index === detailModelActive}"
                v-on:click="changeDetailMannequin(index)">
                <img :src="mannequin.thumbImage">
                <!-- <p>{{ mannequin.typeText }}</p> -->
              </li>
            </ul>
          </div>

          <div class="bl_detail_panel">
            <h5>合わせる靴を選択してください</h5>          
            <ul class="large-select-panel">
              <li
                v-for="(shoes, index) in shoesTypes"
                v-bind:key="shoes.id"
                class="shoes-item"
                v-bind:class="{'shoes-active': index === detailShoesActive}"
                v-on:click="changeDetailShoes(index)">
                <img :src="shoes.thumbImage">
                <!-- <p>{{ shoes.typeText }}</p> -->
              </li>
            </ul>
          </div>

        </div>

        <!-- 詳細　情報 -->
        <div class="bl_detail_info">
          <div class="compare_panel compare_wide">
            <div class="compare_title">
              <h5>洋服のサイズ</h5>
              <div class="title_underline"></div>
            </div>
            <img :src=itemColors[detailColorActive].dressImage class="compare_img">
            <div class="compare_main">
              <div class="compare_box">
                <h5>サイズ</h5><br>
                <h5>総丈</h5><br>
                <h5>裾までの肩下</h5><br>
                <h5>バスト</h5><br>
                <h5>ウエスト</h5><br>
                <h5>ヒップ</h5><br>
              </div>
              <div class="compare_colon">
                <h5>:</h5><br>
                <h5>:</h5><br>
                <h5>:</h5><br>
                <h5>:</h5><br>
                <h5>:</h5><br>
                <h5>:</h5><br>
              </div>
              <div class="compare_box">
                <h5>{{ itemSizes[this.detailSizeActive].sizeText }} サイズ</h5><br>
                <h5>{{ itemSizes[this.detailSizeActive].sizeLength }} cm</h5><br>
                <h5>{{ itemSizes[this.detailSizeActive].sizeShoulder }} cm</h5><br>
                <h5>{{ itemSizes[this.detailSizeActive].sizeBust }} cm</h5><br>
                <h5>{{ itemSizes[this.detailSizeActive].sizeWaist }} cm</h5><br>
                <h5>{{ itemSizes[this.detailSizeActive].sizeHip }} cm</h5><br>
              </div>
            </div>
          </div>
          <div class="compare_panel compare_wide">
            <div class="compare_title">
              <h5>モデルのサイズ</h5>
              <div class="title_underline"></div>
            </div>
            <img src="../assets/image/common/w_o.png" class="compare_img" alt="">
            <div class="compare_main">
              <div class="compare_box">
                <h5 class="white">-</h5><br>
                <h5>身長</h5><br>
                <h5>膝までの肩下</h5><br>
                <h5>バスト</h5><br>
                <h5>ウエスト</h5><br>
                <h5>ヒップ</h5><br>
              </div>
              <div class="compare_colon">
                <h5 class="white">-</h5><br>
                <h5>:</h5><br>
                <h5>:</h5><br>
                <h5>:</h5><br>
                <h5>:</h5><br>
                <h5>:</h5><br>
              </div>
              <div class="compare_box">
                <h5 class="white">-</h5><br>
                <h5>{{ bodyHeight }} cm</h5><br>
                <h5>{{ Math.round(bodyHeight * 0.54545) }} cm</h5><br>
                <h5>{{ Math.round(bodyHeight * 0.52 * bodyWaistRatio / 100) }} cm</h5><br>
                <h5>{{ Math.round(bodyHeight * 0.39 * bodyWaistRatio / 100) }} cm</h5><br>
                <h5>{{ Math.round(bodyHeight * 0.53 * bodyWaistRatio / 100) }} cm</h5><br>
              </div>
            </div>
          </div>
          <div class="compare_panel compare_narrow">
            <div class="compare_title">
              <h5>比較</h5>
              <div class="title_underline"></div>
            </div>
            <div class="compare_main">
              <div class="compare_box">
                <h5 class="white">-</h5><br>
                <h5 class="white">-</h5><br>
                <h5>膝下</h5><br>
                <h5>バスト</h5><br>
                <h5>ウエスト</h5><br>
                <h5>ヒップ</h5><br>
              </div>
              <div class="compare_colon">
                <h5 class="white">-</h5><br>
                <h5 class="white">-</h5><br>
                <h5>:</h5><br>
                <h5>:</h5><br>
                <h5>:</h5><br>
                <h5>:</h5><br>
              </div>
              <div class="compare_box">
                <h5 class="white">-</h5><br>
                <h5 class="white">-</h5><br>
                <h5>{{ itemSizes[this.detailSizeActive].sizeShoulder - Math.round(bodyHeight * 0.54545) }} cm</h5><br>
                <h5 v-bind:class="{ red: itemSizes[this.detailSizeActive].sizeBust < Math.round(bodyHeight * 0.52) }" >{{ itemSizes[this.detailSizeActive].sizeBust - Math.round(bodyHeight * 0.52 * bodyWaistRatio / 100) }} cm</h5><br>
                <h5 v-bind:class="{ red: itemSizes[this.detailSizeActive].sizeWaist < Math.round(bodyHeight * 0.39) }">{{ itemSizes[this.detailSizeActive].sizeWaist - Math.round(bodyHeight * 0.39 * bodyWaistRatio / 100) }} cm</h5><br>
                <h5 v-bind:class="{ red: itemSizes[this.detailSizeActive].sizeHip < Math.round(bodyHeight * 0.53) }">{{ itemSizes[this.detailSizeActive].sizeHip - Math.round(bodyHeight * 0.53 * bodyWaistRatio / 100) }} cm</h5><br>
              </div>
            </div>
          </div>

        </div>
      </div>


    </div>

    <!-- 商品詳細ヒーロー -->
    <!-- <div class="ly_container" id="page_transfer">
      <br>
      <br>
      <br>
      <h4>画面遷移のサンプル</h4>
      <div class="bl_card_cover">

        <div class="bl_card">
          <div class="bl_card_top">
            <div class="bl_card_img">
              <img class="thumbImage" src="../assets/image/fashionwalker/11.jpg">
            </div>
            <div class="bl_dressroom">
              <ul class="image-box">                
                <li class="image-item">
                  <img src="../assets/image/common/t_base_line.png">
                </li>
                <li class="image-item">
                  <img class="thumbImage" src="../assets/image/fashionwalker/11.png">
                </li>
              </ul>
            </div>
          </div>
          <div class="bl_card_text">
            <p> name </p>
            <p> brand </p>
            <p> shop </p>
            <p> price | addComma  円</p>
            <p >肩下  item.length  cm</p>
          </div>

        </div>
        <div class="bl_card_2">
          a
        </div>
        <div class="bl_card_2">
          a
        </div>
      </div>
    </div> -->



    <!-- サイズミルとは？ ヒーロー -->
    <div class="ly_container">
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <h4>サイズミルでは</h4>
      <div class="underline"></div>
      <br>
      <br>
      <br>
      <h5>「自分とは違う身長のモデルが、モデルに合ったサイズの洋服を着た画像」から</h5>
      <h5>「自分と同じ身長のモデルが、自分に合ったサイズの洋服を着た画像」へ！</h5>
      <h5>これからはすべての洋服を試着してみて、自分が欲しいサイズの洋服が選べます！</h5>
      <br>
      <br>
    </div>
    <div class="ly_flex_container">
			<div class="w50">
				<img src="../assets/image/common/a300x300.jpg" alt="">
			</div>
			<div class="w50">
				<img src="../assets/image/common/b300x300.jpg" alt="">
			</div>
			<div class="w50">
        <p>このサイズの洋服は自分が着たらどうなるの？<br>
        オンラインショップでは試着ができないから、<br>
        実際に自分が着た時にどう見えるか教えて！</p>
			</div>
			<div class="w50">
        <p>自分の身長や体型で、服を着た姿を確認！<br>
        寸法表示だけでは分かりにくい服の丈感を、<br>
        自分の身長に "合わせて見て" 確認できます！</p>
			</div>
    </div>
      <br>
      <br>

    <!-- 肩下とは？ ヒーロー -->
    <div class="ly_container">
      <br>
      <br>
      <br>
      <br>
      <br>
      <h4>「肩下」とは</h4>
      <div class="underline"></div>
      <br>
      <br>
      <br>
      <h5><span class="txt_highlight">「肩下」</span>とは、肩から下の垂直距離です。</h5>
      <h5>これまでの"身長"と"総丈"では、洋服の裾が膝下何センチになるか測ることはできませんでした。</h5>
      <h5>キテミルは、世界で初めて<span class="txt_highlight">「肩下」</span>という新しい採寸の概念を考案、サイズ測定の新基準を提案します。</h5>
      <br>
      <br>
    </div>
    <div class="ly_flex_container">
			<div class="w50_w">
				<img src="../assets/image/common/c300x300.jpg" alt="">
			</div>

			<div class="w50_w">
				<img src="../assets/image/common/d300x300.jpg" alt="">
			</div>
      <div class="w50_txt">パンツ → 「股下」</div>
      <div class="w50_txt">トップス、アウター、ワンピース → 「肩下」</div>
			<div class="w50">
        <p>"身長"と"総丈"だけでは、裾の位置はわかりません。<br>
        <span class="txt_highlight">"股下"</span>という、身体と洋服の共通基準があるため、<br>
        試着しなくてもパンツの裾の位置はわかります。</p>
			</div>
			<div class="w50">
        <p>"身長"と"総丈"だけでは、膝と裾の長さは測れません。<br>
        身体と洋服に<span class="txt_highlight">"肩下"</span>という新しい基準を導入することで、<br>
        試着しなくても裾の位置がわかるようになります！</p>
			</div>
    </div>
      <br>
      <br>

    <!-- メリットヒーロー -->
    <div class="ly_container">
      <br>
      <br>
      <br>
      <br>
      <br>
      <h4>サイズミルの導入メリット</h4>
      <div class="underline"></div>
      <br>
      <br>
      <br>
      <br>
    </div>
    <div class="ly_flex_container">
      <div class="w50">
				<h4>購入率 Up</h4>
				<p>欲しいサイズの洋服が簡単に見つけられて、<br>
				サイトから離脱してしまうことを防ぐため</p>
			</div>
			<div class="w50">
				<h4>返品率 Down</h4>
				<p>購入された洋服が、サイズの間違いで<br>
				返品になってしまうことを防ぐため</p>
			</div>
			<div class="w50">
				<h4>購入単価 Up</h4>
				<p>試着できないECではなかなか買いにくかった<br>
				高単価な商品を購入してもらうため</p>
			</div>
			<div class="w50">
				<h4>リピート率 Up</h4>
				<p>サイズの不安や返品の不安を解消して<br>
				お客様満足度、信頼度を向上するため</p>
			</div>
    </div>
      <br>
      <br>
    <div class="ly_container">
      <br>
      <br>
      <br>
      <br>
      <br>
      <h4>お問い合わせ</h4>
      <div class="underline"></div>
      <br>
      <br>
      <br>
      <br>
      <div class="w300">
        <p>会社名&emsp;:&emsp;株式会社キテミル</p>
        <p>URL&emsp;:&emsp;<a href="https://kitemiru.jp/">https://kitemiru.jp/</a></p>
        <p>連絡先&emsp;:&emsp;info@kitemiru.jp&emsp;<a href="mailto:info@kitemiru.jp"><font-awesome-icon icon="paper-plane" /></a></p>
        <h5>* 本件は国際特許出願中です。</h5>
        <h5><span class="white">* </span>国際出願番号 : PCT/JP 2020 / 018744</h5>
      </div>
      <br>
      <br>
    </div>
    <!-- フッター -->
    <div class="ly_footer">

			<h3>&copy; 2017 Kitemiru. All Rights Reserved.</h3>

    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
    // デフォルト設定
      // 表示形式を選択（並列/商品/試着室）
      showActive: '1',

      // 表示順を選択（新着順:id/価格順:price/総丈順:length）
      sort: {
        key: '', // ソートキー
        isAsc: false // 昇順ならtrue,降順ならfalse
      },

      // カラーを選択（0~12）
      colorActive: 0,

      // カテゴリーを選択（0~12）
      categoryActive: 0,

      // カード2の表示切り替え
      isActive: false,
      
      // 裾の位置を選択（ショート/ミドル/ロング）
      lengthActive: 0,


      // 詳細 カラー選択
      detailColorActive: 0,

      // 詳細 サイズ選択
      detailSizeActive: 1,
      sizeBase: 1,
      // 詳細 モデル選択
      detailModelActive: 0,
      // 詳細 シューズ選択
      detailShoesActive: 0,


      // 身長を選択（146cm 〜 176cm = 160cm ±10%）
      bodyHeight: this.$store.state.height,

      // 基準体型
      bodyWaistRatio: 100,
      bodyBust: 86,
      bodyWaist: 1,
      bodyHip: 93,

      // 服の種類を選択（アウター/ワンピース/セーター）
      typeActive: 0,

      val: '',
      // show: true,
  
      // 基準ライン
      marginHead: -264,
      marginShoulder: -184,
      marginWaist: -80,
      marginCrotch: 0,
      marginKnee: 90,
      marginShoes: 262,
      marginFloor: 240,

      sizeRatioSide: 2/3,
      sizeRatioCard: 0.25,
      sizeRatioCard2: 0.4,
      sizeRatioDetail: 0.9,

      baseHeight: 160,

      // カテゴリー
      categories: [
        { categoryId: "cat_00",
          categoryImage: require('../assets/image/common/all.png'),
          categoryName: "全て"
        },
        { categoryId: "cat_01",
          categoryImage: require('../assets/image/category/1.png'),
          categoryName: "ワンピース"
        },
        { categoryId: "cat_02",
          categoryImage: require('../assets/image/category/4.png'),
          categoryName: "アウター"
        },
        { categoryId: "cat_03",
          categoryImage: require('../assets/image/category/12.png'),
          categoryName: "パンツ"
        },
        { categoryId: "cat_04",
          categoryImage: require('../assets/image/category/2.png'),
          categoryName: "トップス"
        },
        { categoryId: "cat_05",
          categoryImage: require('../assets/image/category/10.png'),
          categoryName: "セーター"
        },
        { categoryId: "cat_06",
          categoryImage: require('../assets/image/category/3.png'),
          categoryName: "スカート"
        },
        { categoryId: "cat_7",
          categoryImage: require('../assets/image/category/7.png'),
          categoryName: "シューズ"
        },
      ],

      // カラー
      colors: [
        { colorId: "color_00",
          colorImage: require('../assets/image/common/all.png'),
          colorName: "all",
          colorKana: "全て"
        },
        { colorId: "color_01",
          colorImage: require('../assets/image/colors/1.png'),
          colorName: "white",
          colorKana: "ホワイト"
        },
        { colorId: "color_02",
          colorImage: require('../assets/image/colors/2.png'),
          colorName: "gray",
          colorKana: "グレー"
        },
        { colorId: "color_03",
          colorImage: require('../assets/image/colors/3.png'),
          colorName: "black",
          colorKana: "ブラック"
        },
        { colorId: "color_04",
          colorImage: require('../assets/image/colors/4.png'),
          colorName: "brown",
          colorKana: "ブラウン"
        },
        { colorId: "color_05",
          colorImage: require('../assets/image/colors/5.png'),
          colorName: "beige",
          colorKana: "ベージュ"
        },
        { colorId: "color_06",
          colorImage: require('../assets/image/colors/6.png'),
          colorName: "red",
          colorKana: "レッド"
        },
        { colorId: "color_07",
          colorImage: require('../assets/image/colors/7.png'),
          colorName: "yellow",
          colorKana: "イエロー"
        },
        { colorId: "color_08",
          colorImage: require('../assets/image/colors/8.png'),
          colorName: "green",
          colorKana: "グリーン"
        },
        { colorId: "color_09",
          colorImage: require('../assets/image/colors/9.png'),
          colorName: "blue",
          colorKana: "ブルー"
        },
        { colorId: "color_10",
          colorImage: require('../assets/image/colors/10.png'),
          colorName: "purple",
          colorKana: "パープル"
        },
        // { colorId: "color_11",
        //   colorImage: require('../assets/image/colors/11.png'),
        //   colorName: "gold",
        //   colorKana: "金・銀・クリア"
        // },
        // { colorId: "color_12",
        //   colorImage: require('../assets/image/colors/12.png'),
        //   colorName: "mix",
        //   colorKana: "ミックス"
        // }
      ],

      // 裾の位置
      lengths: [
        {
          id: 11,
          name: '全て',
          dressImage: require('../assets/image/common/band0.png')
        },
        {
          id: 12,
          name: 'ショート',
          dressImage: require('../assets/image/common/bands.png')
        },
        {
          id: 13,
          name: 'ミドル',
          dressImage: require('../assets/image/common/band2.png')
        },
        {
          id: 14,
          name: 'ロング',
          dressImage: require('../assets/image/common/bandl.png')
        },
      ],

      // 詳細 カラー情報
      itemColors: [
        {
          id: 11,
          color: 'オレンジ',
          thumbImage: require('../assets/image/fashionwalker/11.jpg'),
          dressImage: require('../assets/image/fashionwalker/11.png')
        },
        {
          id: 12,
          color: 'ダスティ',
          thumbImage: require('../assets/image/fashionwalker/12.jpg'),
          dressImage: require('../assets/image/fashionwalker/12.png')
        },
        {
          id: 13,
          color: 'ラズベリー',
          thumbImage: require('../assets/image/fashionwalker/13.jpg'),
          dressImage: require('../assets/image/fashionwalker/13.png')
        },
      ],

      // 詳細 サイズ情報
      itemSizes: [
        {
          id: 21,
          sizeText: 'S',
          sizeShoulder: 101,
          sizeLength: 106,
          sizeBust: 90,
          sizeWaist: 62,
          sizeHip: 90
        },
        {
          id: 22,
          sizeText: 'M',
          sizeShoulder: 104,
          sizeLength: 109,
          sizeBust: 96,
          sizeWaist: 66,
          sizeHip: 96
        },
        {
          id: 23,
          sizeText: 'L',
          sizeShoulder: 107,
          sizeLength: 112,
          sizeBust: 102,
          sizeWaist: 70,
          sizeHip: 102
        }
      ],
      // 詳細 マネキン画像
      mannequinTypes: [
        {
          id: 51,
          typeText: '女性①',
          thumbImage: require('../assets/image/common/base_white.jpg'),
          bodyImage: require('../assets/image/common/w_o.png')
        },
        {
          id: 52,
          typeText: '女性②',
          thumbImage: require('../assets/image/common/base_model1.jpg'),
          bodyImage: require('../assets/image/common/base_model1.png')
        },
        {
          id: 53,
          typeText: '女性③',
          thumbImage: require('../assets/image/common/base_model2.jpg'),
          bodyImage: require('../assets/image/common/base_model2.png')
        },
        {
          id: 54,
          typeText: '輪郭線',
          thumbImage: require('../assets/image/common/base_model3.jpg'),
          bodyImage: require('../assets/image/common/base_model3.png')
        }
      ],

      // 詳細 シューズ画像
      shoesTypes: [
        {
          id: 61,
          thumbImage: require('../assets/image/items/16j030-13.jpg'),
          dressImage: require('../assets/image/items/16j030-13.png')
        },
        {
          id: 62,
          thumbImage: require('../assets/image/items/16d014-28.jpg'),
          dressImage: require('../assets/image/items/16d014-28.png')
        },
        {
          id: 63,
          thumbImage: require('../assets/image/items/16g021-11.jpg'),
          dressImage: require('../assets/image/items/16g021-11.png')
        },
        {
          id: 64,
          thumbImage: require('../assets/image/items/16d011-28.jpg'),
          dressImage: require('../assets/image/items/16d011-28.png')
        },
        {
          id: 65,
          thumbImage: require('../assets/image/items/16k006-10.jpg'),
          dressImage: require('../assets/image/items/16k006-10.png')
        },
        {
          id: 66,
          thumbImage: require('../assets/image/items/16d001-14.jpg'),
          dressImage: require('../assets/image/items/16d001-14.png')
        }
      ],

      // アイテム
      items: [
        {
          id : "16d001-07",
          category : 1,
          baseLine : -184,
          shop : "ファッションウォーカー",
          brand : "Apuweiser-riche",
          color: 7,
          name : "フロッキーチェックフラワーワンピース",
          price : 25000 ,
          length : 83,
          thumbImage:require('../assets/image/items/16d001-07.jpg'),
          dressImage:require('../assets/image/items/16d001-07.png')
        },
{id:"16d004-24",category:1,baseLine:-184,shop:"ELLE SHOP",brand: "Velnica.",color:10,name:"オフショルダーワンピース",price:26000 ,length:81,thumbImage:require('../assets/image/items/16d004-24.jpg'),dressImage:require('../assets/image/items/16d004-24.png')},
{id:"16l005-07",category:1,baseLine:-184,shop:"USAGI ONLINE 公式通販",brand: "gelato pique",color:10,name:"【Xmas限定】チュールマキシドレス",price:8800 ,length:118,thumbImage:require('../assets/image/items/16l005-07.jpg'),dressImage:require('../assets/image/items/16l005-07.png')},
{id:"16l007-02",category:1,baseLine:-184,shop:"ファッションウォーカー",brand: "Noela",color:3,name:"オリジナルオータムリリー柄ワンピ",price:13000 ,length:81,thumbImage:require('../assets/image/items/16l007-02.jpg'),dressImage:require('../assets/image/items/16l007-02.png')},
{id:"16d001-02",category:6,baseLine:-80,shop:"ファッションウォーカー",brand: "Supreme.La.La.",color:9,name:"Oスケープチェックロングスカート",price:13800 ,length:0,thumbImage:require('../assets/image/items/16d001-02.jpg'),dressImage:require('../assets/image/items/16d001-02.png')},
{id:"16d001-04",category:4,baseLine:-184,shop:"ファッションウォーカー",brand: "snidel",color:9,name:"ガーゼオフショルブラウス",price:12200 ,length:39,thumbImage:require('../assets/image/items/16d001-04.jpg'),dressImage:require('../assets/image/items/16d001-04.png')},
{id:"16d001-06",category:2,baseLine:-184,shop:"ファッションウォーカー",brand: "Apuweiser-riche",color:1,name:"チェスターコート(ホワイト)",price:29000 ,length:74,thumbImage:require('../assets/image/items/16d001-06.jpg'),dressImage:require('../assets/image/items/16d001-06.png')},
{id:"16d001-08",category:5,baseLine:-184,shop:"ANAPオンラインショップ",brand: "anap mimpi",color:8,name:"ネイティブ柄 トッパ ーカーディガン",price:3900 ,length:76,thumbImage:require('../assets/image/items/16d001-08.jpg'),dressImage:require('../assets/image/items/16d001-08.png')},
{id:"16d001-09",category:4,baseLine:-184,shop:"ファッションウォーカー",brand: "Apuweiser-riche",color:2,name:"シャツカラーゆるブラウス",price:13000 ,length:52,thumbImage:require('../assets/image/items/16d001-09.jpg'),dressImage:require('../assets/image/items/16d001-09.png')},
{id:"16d001-10",category:6,baseLine:-80,shop:"ファッションウォーカー",brand: "Lily Brown",color:1,name:"レースロングスカート",price:10400 ,length:0,thumbImage:require('../assets/image/items/16d001-10.jpg'),dressImage:require('../assets/image/items/16d001-10.png')},
{id:"16d001-12",category:2,baseLine:-184,shop:"ファッションウォーカー",brand: "Mila Owen",color:1,name:"麻テーラードジャケット",price:14000 ,length:60,thumbImage:require('../assets/image/items/16d001-12.jpg'),dressImage:require('../assets/image/items/16d001-12.png')},
{id:"16d001-14",category:7,baseLine:262,shop:"集英社 FLAGSHOP",brand: "DRWCYS",color:4,name:"ニーハイブーツ",price:16000 ,length:0,thumbImage:require('../assets/image/items/16d001-14.jpg'),dressImage:require('../assets/image/items/16d001-14.png')},
{id:"16d001-16",category:4,baseLine:-184,shop:"ANAPオンラインショップ",brand: "A.C.D.Y",color:8,name:"シンプルTシャツ",price:1000 ,length:55,thumbImage:require('../assets/image/items/16d001-16.jpg'),dressImage:require('../assets/image/items/16d001-16.png')},
{id:"16d001-18",category:6,baseLine:-80,shop:"ファッションウォーカー",brand: "Lily Brown",color:6,name:"サテンレースタイトスカート",price:9800 ,length:0,thumbImage:require('../assets/image/items/16d001-18.jpg'),dressImage:require('../assets/image/items/16d001-18.png')},
{id:"16d001-19",category:4,baseLine:-184,shop:"ファッションウォーカー",brand: "Apuweiser-riche",color:9,name:"デニム抜けシャツ",price:13000 ,length:63,thumbImage:require('../assets/image/items/16d001-19.jpg'),dressImage:require('../assets/image/items/16d001-19.png')},
{id:"16d001-20",category:5,baseLine:-184,shop:"ANAPオンラインショップ",brand: "anap Latina",color:6,name:"ハイネックリブニットTOP",price:1609 ,length:52,thumbImage:require('../assets/image/items/16d001-20.jpg'),dressImage:require('../assets/image/items/16d001-20.png')},
{id:"16d001-23",category:2,baseLine:-184,shop:"ファッションウォーカー",brand: "Supreme.La.La.",color:2,name:"チュールツキトレンチコート",price:18500 ,length:83,thumbImage:require('../assets/image/items/16d001-23.jpg'),dressImage:require('../assets/image/items/16d001-23.png')},
{id:"16d001-24",category:1,baseLine:-184,shop:"ファッションウォーカー",brand: "Apuweiser-riche",color:9,name:"Apuweiser Luxe フラワー刺繍ベアワンピース",price:32000 ,length:87,thumbImage:require('../assets/image/items/16d001-24.jpg'),dressImage:require('../assets/image/items/16d001-24.png')},
{id:"16d001-31",category:6,baseLine:-80,shop:"ファッションウォーカー",brand: "Supreme.La.La.",color:6,name:"Oスケープチェックロングスカート",price:13800 ,length:0,thumbImage:require('../assets/image/items/16d001-31.jpg'),dressImage:require('../assets/image/items/16d001-31.png')},
{id:"16d001-36",category:5,baseLine:-184,shop:"ANAPオンラインショップ",brand: "ANAP",color:1,name:"NETオリジナル ハイネックニット",price:1750 ,length:56,thumbImage:require('../assets/image/items/16d001-36.jpg'),dressImage:require('../assets/image/items/16d001-36.png')},
{id:"16d001-41",category:1,baseLine:-184,shop:"ファッションウォーカー",brand: "snidel",color:10,name:"オーガンジーフラワーセットアップ",price:16000 ,length:79,thumbImage:require('../assets/image/items/16d001-41.jpg'),dressImage:require('../assets/image/items/16d001-41.png')},
{id:"16d002-07",category:1,baseLine:-184,shop:"ファッションウォーカー",brand: "Lily Brown",color:10,name:"オーガンジーリボンワンピース",price:12200 ,length:71,thumbImage:require('../assets/image/items/16d002-07.jpg'),dressImage:require('../assets/image/items/16d002-07.png')},
{id:"16d002-10",category:3,baseLine:-80,shop:"集英社 FLAGSHOP",brand: "ViS",color:9,name:"Lee別注スリムテーパードデニム",price:11000 ,length:0,thumbImage:require('../assets/image/items/16d002-10.jpg'),dressImage:require('../assets/image/items/16d002-10.png')},
{id:"16d002-23",category:2,baseLine:-184,shop:"ファッションウォーカー",brand: "Supreme.La.La.",color:8,name:"ポンチョフウショートトレンチコート",price:17800 ,length:65,thumbImage:require('../assets/image/items/16d002-23.jpg'),dressImage:require('../assets/image/items/16d002-23.png')},
{id:"16d002-40",category:7,baseLine:262,shop:"集英社 FLAGSHOP",brand: "DRWCYS",color:5,name:"ニーハイブーツ",price:16000 ,length:0,thumbImage:require('../assets/image/items/16d002-40.jpg'),dressImage:require('../assets/image/items/16d002-40.png')},
{id:"16d004-12",category:2,baseLine:-184,shop:"ファッションウォーカー",brand: "Apuweiser-riche",color:6,name:"タックドレストレンチコート",price:26000 ,length:82,thumbImage:require('../assets/image/items/16d004-12.jpg'),dressImage:require('../assets/image/items/16d004-12.png')},
{id:"16d004-16",category:4,baseLine:-184,shop:"ANAPオンラインショップ",brand: "anap Latina",color:2,name:"オフショルダーニットトップス",price:2730 ,length:50,thumbImage:require('../assets/image/items/16d004-16.jpg'),dressImage:require('../assets/image/items/16d004-16.png')},
{id:"16d004-17",category:1,baseLine:-184,shop:"ANAPオンラインショップ",brand: "Settimissimo",color:3,name:"ITALY レース切替フィット&フレアワンピース",price:5463 ,length:80,thumbImage:require('../assets/image/items/16d004-17.jpg'),dressImage:require('../assets/image/items/16d004-17.png')},
{id:"16k016-03",category:1,baseLine:-184,shop:"集英社 FLAGSHOP",brand: "Mila Owen",color:5,name:"ボリュームニットワンピース",price:11000 ,length:104,thumbImage:require('../assets/image/items/16k016-03.jpg'),dressImage:require('../assets/image/items/16k016-03.png')},
{id:"16k016-07",category:1,baseLine:-184,shop:"USAGI ONLINE 公式通販",brand: "emmi",color:2,name:"【emmi atelier】レイヤードニットワンピース",price:23000 ,length:85,thumbImage:require('../assets/image/items/16k016-07.jpg'),dressImage:require('../assets/image/items/16k016-07.png')},
{id:"16k017-09",category:1,baseLine:-184,shop:"スタイライフ",brand: "PINKY & DIANNE",color:9,name:"アートフラワープリントワンピース",price:33000 ,length:87,thumbImage:require('../assets/image/items/16k017-09.jpg'),dressImage:require('../assets/image/items/16k017-09.png')},
{id:"16l001-15",category:1,baseLine:-184,shop:"ファッションウォーカー",brand: "FRAY I.D",color:2,name:"ティルトフレアーニットワンピース",price:22000 ,length:85,thumbImage:require('../assets/image/items/16l001-15.jpg'),dressImage:require('../assets/image/items/16l001-15.png')},
{id:"16l002-03",category:1,baseLine:-184,shop:"ファッションウォーカー",brand: "Apuweiser-riche",color:10,name:"袖ファーハートカットタイトワンピース",price:25000 ,length:85,thumbImage:require('../assets/image/items/16l002-03.jpg'),dressImage:require('../assets/image/items/16l002-03.png')},
{id:"16l002-07",category:1,baseLine:-184,shop:"ANAPオンラインショップ",brand: "Anap USA",color:10,name:"スピンドルタイトワンピース",price:6900 ,length:99,thumbImage:require('../assets/image/items/16l002-07.jpg'),dressImage:require('../assets/image/items/16l002-07.png')},
{id:"16l003-02",category:1,baseLine:-184,shop:"ファッションウォーカー",brand: "Apuweiser-riche",color:2,name:"袖ファーハートカットタイトワンピース",price:25000 ,length:85,thumbImage:require('../assets/image/items/16l003-02.jpg'),dressImage:require('../assets/image/items/16l003-02.png')},
{id:"16l003-09",category:1,baseLine:-184,shop:"ANAPオンラインショップ",brand: "Anap USA",color:3,name:"スピンドルタイトワンピース",price:6900 ,length:102,thumbImage:require('../assets/image/items/16l003-09.jpg'),dressImage:require('../assets/image/items/16l003-09.png')},
{id:"16l004-02",category:1,baseLine:-184,shop:"ファッションウォーカー",brand: "Mystrada",color:1,name:"リブセットアップ",price:20000 ,length:97,thumbImage:require('../assets/image/items/16l004-02.jpg'),dressImage:require('../assets/image/items/16l004-02.png')},
{id:"16l004-15",category:1,baseLine:-184,shop:"ファッションウォーカー",brand: "Apuweiser-riche",color:6,name:"袖ファーハートカットタイトワンピース",price:25000 ,length:86,thumbImage:require('../assets/image/items/16l004-15.jpg'),dressImage:require('../assets/image/items/16l004-15.png')},
{id:"16l006-01",category:1,baseLine:-184,shop:"USAGI ONLINE 公式通販",brand: "FRAY I.D",color:4,name:"ラップコンビネゾン",price:26000 ,length:98,thumbImage:require('../assets/image/items/16l006-01.jpg'),dressImage:require('../assets/image/items/16l006-01.png')},
{id:"16l006-02",category:1,baseLine:-184,shop:"ファッションウォーカー",brand: "Mystrada",color:2,name:"リブセットアップ",price:20000 ,length:97,thumbImage:require('../assets/image/items/16l006-02.jpg'),dressImage:require('../assets/image/items/16l006-02.png')},
{id:"16l006-09",category:1,baseLine:-184,shop:"USAGI ONLINE 公式通販",brand: "FRAY I.D",color:5,name:"Aラインフラワーワンピース",price:19000 ,length:80,thumbImage:require('../assets/image/items/16l006-09.jpg'),dressImage:require('../assets/image/items/16l006-09.png')},
{id:"16l006-10",category:1,baseLine:-184,shop:"USAGI ONLINE 公式通販",brand: "FRAY I.D",color:5,name:"タックフリルドレス",price:28000 ,length:115,thumbImage:require('../assets/image/items/16l006-10.jpg'),dressImage:require('../assets/image/items/16l006-10.png')},
{id:"16l006-14",category:1,baseLine:-184,shop:"USAGI ONLINE 公式通販",brand: "FRAY I.D",color:5,name:"切替ヘムフラワーワンピース",price:22000 ,length:81,thumbImage:require('../assets/image/items/16l006-14.jpg'),dressImage:require('../assets/image/items/16l006-14.png')},
{id:"16l007-15",category:1,baseLine:-184,shop:"ファッションウォーカー",brand: "Noela",color:6,name:"オリジナルオータムリリー柄ワンピ",price:13000 ,length:81,thumbImage:require('../assets/image/items/16l007-15.jpg'),dressImage:require('../assets/image/items/16l007-15.png')},
{id:"16l008-03",category:1,baseLine:-184,shop:"ファッションウォーカー",brand: "Noela",color:10,name:"オリジナルオータムリリー柄ワンピ",price:13000 ,length:81,thumbImage:require('../assets/image/items/16l008-03.jpg'),dressImage:require('../assets/image/items/16l008-03.png')},
{id:"16l009-02",category:1,baseLine:-184,shop:"FLANDRE ONLINE STORE",brand: "Maglie par ef-de",color:1,name:"ボア2WAYワンピース",price:59000 ,length:82,thumbImage:require('../assets/image/items/16l009-02.jpg'),dressImage:require('../assets/image/items/16l009-02.png')},
{id:"16l009-09",category:1,baseLine:-184,shop:"FLANDRE ONLINE STORE",brand: "Maglie par ef-de",color:2,name:"ツイード2WAYワンピース",price:49000 ,length:84,thumbImage:require('../assets/image/items/16l009-09.jpg'),dressImage:require('../assets/image/items/16l009-09.png')},
{id:"16l010-02",category:1,baseLine:-184,shop:"FLANDRE ONLINE STORE",brand: "CLEAR IMPRESSION",color:6,name:"ブロックチェックワンピース",price:15000 ,length:92,thumbImage:require('../assets/image/items/16l010-02.jpg'),dressImage:require('../assets/image/items/16l010-02.png')},
{id:"16l010-11",category:1,baseLine:-184,shop:"FLANDRE ONLINE STORE",brand: "ef-de",color:2,name:"ウール混ギンガムチェックワンピース",price:36000 ,length:87,thumbImage:require('../assets/image/items/16l010-11.jpg'),dressImage:require('../assets/image/items/16l010-11.png')},
{id:"16l010-15",category:1,baseLine:-184,shop:"theory",brand: "Theory",color:3,name:"Peony Lace Geremy WB",price:44000 ,length:81,thumbImage:require('../assets/image/items/16l010-15.jpg'),dressImage:require('../assets/image/items/16l010-15.png')},
{id:"16l011-03",category:1,baseLine:-184,shop:"ファッションウォーカー",brand: "Apuweiser-riche",color:2,name:"ベルト付チェック裾フレアワンピース",price:24000 ,length:86,thumbImage:require('../assets/image/items/16l011-03.jpg'),dressImage:require('../assets/image/items/16l011-03.png')},
{id:"16l011-07",category:1,baseLine:-184,shop:"FLANDRE ONLINE STORE",brand: "CLEAR IMPRESSION",color:8,name:"ブロックチェックワンピース",price:15000 ,length:92,thumbImage:require('../assets/image/items/16l011-07.jpg'),dressImage:require('../assets/image/items/16l011-07.png')},
{id:"16l012-02",category:1,baseLine:-184,shop:"USAGI ONLINE 公式通販",brand: "Mila Owen",color:10,name:"ニットプリーツセットアップ",price:14000 ,length:116,thumbImage:require('../assets/image/items/16l012-02.jpg'),dressImage:require('../assets/image/items/16l012-02.png')},
{id:"16l012-09",category:1,baseLine:-184,shop:"ファッションウォーカー",brand: "Apuweiser-riche",color:5,name:"袖ファーフレアニットワンピース",price:22000 ,length:90,thumbImage:require('../assets/image/items/16l012-09.jpg'),dressImage:require('../assets/image/items/16l012-09.png')},
{id:"16l013-15",category:1,baseLine:-184,shop:"USAGI ONLINE 公式通販",brand: "emmi",color:4,name:"【emmi atelier】ジャンパードレス",price:24000 ,length:104,thumbImage:require('../assets/image/items/16l013-15.jpg'),dressImage:require('../assets/image/items/16l013-15.png')},
{id:"16m001-01",category:1,baseLine:-184,shop:"ファッションウォーカー",brand: "Mystrada",color:4,name:"Vネックフレアワンピース",price:21000 ,length:105,thumbImage:require('../assets/image/items/16m001-01.jpg'),dressImage:require('../assets/image/items/16m001-01.png')},
{id:"16m002-09",category:1,baseLine:-184,shop:"ファッションウォーカー",brand: "L'EST ROSE",color:6,name:"ベルト付ニットミドルワンピ―ス",price:7700 ,length:82,thumbImage:require('../assets/image/items/16m002-09.jpg'),dressImage:require('../assets/image/items/16m002-09.png')},
{id:"16m003-02",category:1,baseLine:-184,shop:"ファッションウォーカー",brand: "L'EST ROSE",color:9,name:"ベルト付ニットミドルワンピ―ス",price:7700 ,length:81,thumbImage:require('../assets/image/items/16m003-02.jpg'),dressImage:require('../assets/image/items/16m003-02.png')},
{id:"16m003-15",category:1,baseLine:-184,shop:"ファッションウォーカー",brand: "MERCURYDUO",color:2,name:"アンゴラ混シンプルVニットOP",price:9800 ,length:84,thumbImage:require('../assets/image/items/16m003-15.jpg'),dressImage:require('../assets/image/items/16m003-15.png')},
{id:"16m004-03",category:1,baseLine:-184,shop:"ファッションウォーカー",brand: "MERCURYDUO",color:1,name:"アンゴラ混シンプルVニットOP",price:9800 ,length:84,thumbImage:require('../assets/image/items/16m004-03.jpg'),dressImage:require('../assets/image/items/16m004-03.png')},
{id:"16m004-07",category:1,baseLine:-184,shop:"レディースファッション通販夢展望",brand: "Newlyme",color:9,name:"アンティーク風花柄フィット&フレアワンピース",price:2769 ,length:80,thumbImage:require('../assets/image/items/16m004-07.jpg'),dressImage:require('../assets/image/items/16m004-07.png')},
{id:"16m005-02",category:1,baseLine:-184,shop:"ファッションウォーカー",brand: "MERCURYDUO",color:4,name:"アンゴラ混シンプルVニットOP",price:9800 ,length:84,thumbImage:require('../assets/image/items/16m005-02.jpg'),dressImage:require('../assets/image/items/16m005-02.png')},
{id:"16m005-09",category:1,baseLine:-184,shop:"レディースファッション通販夢展望",brand: "Newlyme",color:6,name:"アンティーク風花柄フィット&フレアワンピース",price:2769 ,length:79,thumbImage:require('../assets/image/items/16m005-09.jpg'),dressImage:require('../assets/image/items/16m005-09.png')},
{id:"16m006-15",category:1,baseLine:-184,shop:"ファッションウォーカー",brand: "FURFUR",color:4,name:"ロゼットデシンワンピース",price:24000 ,length:79,thumbImage:require('../assets/image/items/16m006-15.jpg'),dressImage:require('../assets/image/items/16m006-15.png')},
{id:"16m007-07",category:1,baseLine:-184,shop:"レディースファッション通販夢展望",brand: "Newlyme",color:6,name:"選べるラウンド&Vネックふわふわシャギーニットワンピース",price:2306 ,length:73,thumbImage:require('../assets/image/items/16m007-07.jpg'),dressImage:require('../assets/image/items/16m007-07.png')},
{id:"16m008-06",category:3,baseLine:-80,shop:"ファッションウォーカー",brand: "fifth",color:6,name:"プリーツロングワイドパンツ",price:1843 ,length:0,thumbImage:require('../assets/image/items/16m008-06.jpg'),dressImage:require('../assets/image/items/16m008-06.png')},
{id:"16m008-07",category:3,baseLine:-80,shop:"ファッションウォーカー",brand: "color",color:5,name:"ウエストリボンワイドパンツ",price:2954 ,length:0,thumbImage:require('../assets/image/items/16m008-07.jpg'),dressImage:require('../assets/image/items/16m008-07.png')},
{id:"16m008-15",category:2,baseLine:-184,shop:"ファッションウォーカー",brand: "clear",color:2,name:"ステンカラーWボタンウールコート",price:17000 ,length:85,thumbImage:require('../assets/image/items/16m008-15.jpg'),dressImage:require('../assets/image/items/16m008-15.png')},
{id:"16m009-03",category:4,baseLine:-184,shop:"ファッションウォーカー",brand: "color",color:4,name:"無地スキッパーシャツ",price:2769 ,length:59,thumbImage:require('../assets/image/items/16m009-03.jpg'),dressImage:require('../assets/image/items/16m009-03.png')},
{id:"16m009-06",category:1,baseLine:-184,shop:"ファッションウォーカー",brand: "fifth",color:2,name:"フロントスリットニットワンピース",price:3323 ,length:103,thumbImage:require('../assets/image/items/16m009-06.jpg'),dressImage:require('../assets/image/items/16m009-06.png')},
{id:"16m009-08",category:2,baseLine:-184,shop:"ファッションウォーカー",brand: "Apuweiser-riche",color:2,name:"フードファー付5WAYコート",price:69000 ,length:79,thumbImage:require('../assets/image/items/16m009-08.jpg'),dressImage:require('../assets/image/items/16m009-08.png')},
{id:"17a001-09",category:1,baseLine:-184,shop:"ファッションウォーカー",brand: "Lily Brown",color:7,name:"グラデーション刺繍ワンピース",price:16000 ,length:104,thumbImage:require('../assets/image/items/17a001-09.jpg'),dressImage:require('../assets/image/items/17a001-09.png')},
{id:"17a001-11",category:1,baseLine:-184,shop:"ファッションウォーカー",brand: "Lily Brown",color:8,name:"フラワー刺繍ワンピース",price:24000 ,length:104,thumbImage:require('../assets/image/items/17a001-11.jpg'),dressImage:require('../assets/image/items/17a001-11.png')},
{id:"17a001-12",category:1,baseLine:-184,shop:"ファッションウォーカー",brand: "snidel",color:5,name:"エンブロイダリーチュールチュニック",price:17000 ,length:60,thumbImage:require('../assets/image/items/17a001-12.jpg'),dressImage:require('../assets/image/items/17a001-12.png')},
{id:"17a001-18",category:1,baseLine:-184,shop:"ファッションウォーカー",brand: "snidel",color:5,name:"カラーポイントミニワンピース",price:15000 ,length:72,thumbImage:require('../assets/image/items/17a001-18.jpg'),dressImage:require('../assets/image/items/17a001-18.png')},
{id:"17a002-04",category:1,baseLine:-184,shop:"ファッションウォーカー",brand: "color",color:4,name:"ケーブル編みニットワンピース",price:3323 ,length:84,thumbImage:require('../assets/image/items/17a002-04.jpg'),dressImage:require('../assets/image/items/17a002-04.png')},
{id:"17a002-15",category:1,baseLine:-184,shop:"USAGI ONLINE 公式通販",brand: "Lily Brown",color:9,name:"袖刺繍オフショルロンパース",price:1300 ,length:108,thumbImage:require('../assets/image/items/17a002-15.jpg'),dressImage:require('../assets/image/items/17a002-15.png')},
{id:"17a002-18",category:1,baseLine:-184,shop:"USAGI ONLINE 公式通販",brand: "Lily Brown",color:1,name:"レースオフショルワンピース",price:18000 ,length:116,thumbImage:require('../assets/image/items/17a002-18.jpg'),dressImage:require('../assets/image/items/17a002-18.png')},
{id:"17a003-03",category:1,baseLine:-184,shop:"ファッションウォーカー",brand: "color",color:2,name:"ケーブル編みニットワンピース",price:3323 ,length:85,thumbImage:require('../assets/image/items/17a003-03.jpg'),dressImage:require('../assets/image/items/17a003-03.png')},
{id:"17a003-08",category:1,baseLine:-184,shop:"ファッションウォーカー",brand: "snidel",color:1,name:"ウエストリボンシャツワンピース",price:16000 ,length:73,thumbImage:require('../assets/image/items/17a003-08.jpg'),dressImage:require('../assets/image/items/17a003-08.png')},
{id:"17a003-09",category:1,baseLine:-184,shop:"ファッションウォーカー",brand: "Rirandture",color:9,name:"3WAYドレス",price:28000 ,length:82,thumbImage:require('../assets/image/items/17a003-09.jpg'),dressImage:require('../assets/image/items/17a003-09.png')},
{id:"17a003-11",category:1,baseLine:-184,shop:"ファッションウォーカー",brand: "Avan Lily",color:1,name:"タイプライターシャツOP",price:4990 ,length:87,thumbImage:require('../assets/image/items/17a003-11.jpg'),dressImage:require('../assets/image/items/17a003-11.png')},
{id:"17a003-15",category:5,baseLine:-184,shop:"ファッションウォーカー",brand: "Apuweiser-riche",color:2,name:"ロングカーディガン",price:12000 ,length:81,thumbImage:require('../assets/image/items/17a003-15.jpg'),dressImage:require('../assets/image/items/17a003-15.png')},
{id:"17a003-16",category:1,baseLine:-184,shop:"FLANDRE ONLINE STORE",brand: "Maglie par ef-de",color:6,name:"センタータックAラインワンピース",price:39000 ,length:83,thumbImage:require('../assets/image/items/17a003-16.jpg'),dressImage:require('../assets/image/items/17a003-16.png')},
{id:"17a003-18",category:1,baseLine:-184,shop:"ファッションウォーカー",brand: "snidel",color:1,name:"コットンエンブロイダリーワンピース",price:18000 ,length:75,thumbImage:require('../assets/image/items/17a003-18.jpg'),dressImage:require('../assets/image/items/17a003-18.png')},
{id:"18a001-01",category:1,baseLine:-184,shop:"ファッションウォーカー",brand: "Lily Brown",color:1,name:"ニットドッキングワンピース",price:14520 ,length:75,thumbImage:require('../assets/image/items/18a001-01.jpg'),dressImage:require('../assets/image/items/18a001-01.png')},
{id:"18a001-02",category:1,baseLine:-184,shop:"ユニクロオンラインストア",brand: "Uniqlo",color:7,name:"3Dコットンリブクルーネックワンピース",price:4990 ,length:80,thumbImage:require('../assets/image/items/18a001-02.jpg'),dressImage:require('../assets/image/items/18a001-02.png')},
{id:"18a001-03",category:1,baseLine:-184,shop:"ユニクロオンラインストア",brand: "Uniqlo",color:7,name:"3Dコットンリブクルーネックワンピース",price:4990 ,length:85,thumbImage:require('../assets/image/items/18a001-03.jpg'),dressImage:require('../assets/image/items/18a001-03.png')},
{id:"18a001-04",category:1,baseLine:-184,shop:"ユニクロオンラインストア",brand: "Uniqlo",color:7,name:"3Dコットンリブクルーネックワンピース",price:4990 ,length:90,thumbImage:require('../assets/image/items/18a001-04.jpg'),dressImage:require('../assets/image/items/18a001-04.png')},
{id:"18a001-05",category:1,baseLine:-184,shop:"R-online The Shop",brand: "LESTERA",color:3,name:"ブッチャードレス",price:37400 ,length:93,thumbImage:require('../assets/image/items/18a001-05.jpg'),dressImage:require('../assets/image/items/18a001-05.png')},
{id:"18a001-06",category:1,baseLine:-184,shop:"R-online The Shop",brand: "LESTERA",color:1,name:"ブッチャードレス",price:37400 ,length:93,thumbImage:require('../assets/image/items/18a001-06.jpg'),dressImage:require('../assets/image/items/18a001-06.png')},
{id:"18a001-07",category:1,baseLine:-184,shop:"ファッションウォーカー",brand: "Rirandture",color:7,name:"エアリーティアードドッキングワンピース",price:21600 ,length:104,thumbImage:require('../assets/image/items/18a001-07.jpg'),dressImage:require('../assets/image/items/18a001-07.png')},
{id:"18a001-08",category:1,baseLine:-184,shop:"ファッションウォーカー",brand: "Rirandture",color:9,name:"エアリーティアードドッキングワンピース",price:21600 ,length:104,thumbImage:require('../assets/image/items/18a001-08.jpg'),dressImage:require('../assets/image/items/18a001-08.png')},
{id:"18a001-09",category:1,baseLine:-184,shop:"ファッションウォーカー",brand: "Rirandture",color:6,name:"エアリーティアードドッキングワンピース",price:21600 ,length:104,thumbImage:require('../assets/image/items/18a001-09.jpg'),dressImage:require('../assets/image/items/18a001-09.png')},
{id:"16d011-28",category:7,baseLine:262,shop:"株式会社チヨダ",brand: "Timberland",color:7,name:"ティンバーランド Timberland 8561B",price:21000 ,length:0,thumbImage:require('../assets/image/items/16d011-28.jpg'),dressImage:require('../assets/image/items/16d011-28.png')},
{id:"16j030-13",category:7,baseLine:262,shop:"スタイライフ",brand: "glifeed",color:9,name:"スカラップゴールドヒールバレエ",price:4000 ,length:0,thumbImage:require('../assets/image/items/16j030-13.jpg'),dressImage:require('../assets/image/items/16j030-13.png')},
{id:"16k006-10",category:7,baseLine:262,shop:"DURAS公式通販サイト",brand: "duras",color:4,name:"フェイクスエードルーズショートブーツ",price:15500 ,length:0,thumbImage:require('../assets/image/items/16k006-10.jpg'),dressImage:require('../assets/image/items/16k006-10.png')},
{id:"16d013-40",category:7,baseLine:262,shop:"株式会社チヨダ",brand: "Luxury ",color:9,name:"[ラグジュアリー] Luxury M-003 ",price:2890 ,length:0,thumbImage:require('../assets/image/items/16d013-40.jpg'),dressImage:require('../assets/image/items/16d013-40.png')},
{id:"16d014-28",category:7,baseLine:262,shop:"株式会社チヨダ",brand: "Luxury ",color:1,name:"[ラグジュアリー] Luxury M-003 ",price:2890 ,length:0,thumbImage:require('../assets/image/items/16d014-28.jpg'),dressImage:require('../assets/image/items/16d014-28.png')},
{id:"16g021-11",category:7,baseLine:262,shop:"株式会社チヨダ",brand: "ELLE PLANETE",color:3,name:"ELLE　PLANETE PTL715  ポインテッドトゥパンプス",price:4890 ,length:0,thumbImage:require('../assets/image/items/16g021-11.jpg'),dressImage:require('../assets/image/items/16g021-11.png')},
{id:"16m003-08",category:2,baseLine:-184,shop:"ファッションウォーカー",brand: "MERCURYDUO",color:6,name:"テロンチコート",price:17000 ,length:118,thumbImage:require('../assets/image/items/16m003-08.jpg'),dressImage:require('../assets/image/items/16m003-08.png')},
{id:"16l011-06",category:2,baseLine:-184,shop:"FLANDRE ONLINE STORE",brand: "Maglie par ef-de",color:2,name:"ファーフード付きウールコート",price:89000 ,length:90,thumbImage:require('../assets/image/items/16l011-06.jpg'),dressImage:require('../assets/image/items/16l011-06.png')},
{id:"16l008-12",category:2,baseLine:-184,shop:"ファッションウォーカー",brand: "Ungrid",color:1,name:"Casual ジャカードニットガウン",price:21490 ,length:70,thumbImage:require('../assets/image/items/16l008-12.jpg'),dressImage:require('../assets/image/items/16l008-12.png')},
      ]
    }
  },
  methods: {
    slideStart () {
    },
    slideStop: function() {
      this.$store.state.height = this.bodyHeight
      this.hemHeight = this.bodyHeight * 274 / 504
      this.rangeHigh = this.bodyHeight * 242 / 504
      this.rangeLow = this.bodyHeight * 306 / 504
    },
    w_slideStart () {
    },
    w_slideStop: function() {
      this.bodyWaist = this.bodyWaistRatio + this.bodyHeight / 100
    },
  	mouseOver: function(){
      this.isActive = true
    },
    mouseLeave: function(){
    	this.isActive = false
    },

    showChange: function(index) {
      this.showActive = index
      console.log(this.showActive)
    },

    changeLength: function(index) {
      this.hemHeight = this.bodyHeight * 274 / 504
      this.rangeHigh = this.bodyHeight * 242 / 504
      this.rangeLow = this.bodyHeight * 306 / 504
      this.lengthActive = index
    },
    changeColor: function(index) {
      this.colorActive = index
    },
    changeCategory: function(index) {
      this.categoryActive = index
    },

    // 詳細画面
    changeDetailColor: function(index) {
      this.detailColorActive = index
      console.log('color: ' + this.detailColorActive)
    },
    changeDetailSize: function(index) {
      this.detailSizeActive = index
      console.log('size: ' + this.detailSizeActive)
    },
    changeDetailMannequin: function(index) {
      this.detailModelActive = index
      console.log('model: ' + this.detailModelActive)
    },
    changeDetailShoes: function(index) {
      this.detailShoesActive = index
      console.log('shoes: ' + this.detailShoesActive)
    },



    // sort用キーをセットし、昇順・降順を入れ替える
    sortBy: function(key) {
      this.sort.isAsc = this.sort.key === key ? !this.sort.isAsc : false;
      this.sort.key = key;
    },
    sortedClass: function(key) {
      return this.sort.key === key ? `sorted ${this.sort.isAsc ? 'asc' : 'desc' }` : '';
    }
  },
    computed: {
      eventedAction: function() {
        let list = this.items.slice();

        // // カラーでフィルタリング実施
        if(this.colorActive) {
          list = list.filter(element => {
            return element.color === this.colorActive;
          });
        }
        // // カラーでフィルタリング実施
        if(this.categoryActive) {
          list = list.filter(element => {
            return element.category === this.categoryActive;
          });
        }

        // 裾の位置でフィルタリング
        if(this.lengthActive === 1 ) {
          list = list.filter(element => {
            return element.length <= this.hemHeight && element.length != 0
          });
        }
        if(this.lengthActive === 2 ) {
          list = list.filter(element => {
            return element.length >= this.rangeHigh && element.length <= this.rangeLow && element.length != 0
          });
        }
        if(this.lengthActive === 3 ) {
          list = list.filter(element => {
            return element.length >= this.hemHeight && element.length != 0
          });
        }

        // ソート実施
        if(this.sort.key) {
          list.sort((a, b) => {
            a = a[this.sort.key];
            b = b[this.sort.key];
            return (a === b ? 0 : a > b ? 1 : -1) * (this.sort.isAsc ? 1 : -1);
          });
        }

        return list;
      }
    },
    // 金額のカンマ表示
    filters: {
      addComma: function (val) {
        return val.toLocaleString();
      }
 
  }
}
</script>

<style lang="scss" scoped>

// グローバル //
ul{
  margin: 0;
  padding: 0;
}
li{
  list-style: none;
}
a {
  // font-weight: bold;
  color: #2c3e50;
  font-size: 14px;

  &.router-link-exact-active {
    color: #42b983;
  }
}


// レイアウト //

// コンテナ
.home {
  width: 100%;
  max-width: 1240px;
  margin: 0 auto;
}
.ly_container {
  width: 100%;
  max-width: 1240px;
  margin: 0 auto;
}
.ly_flex_container{
  width: 100%;
  max-width: 900px;
  margin: 0 auto;  
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: stretch;
}

// メイン
.ly_cont {
  display: flex;
  width: 100%;
  max-width: 1240px;
  height: 807px;
  border-top: 10px solid #eee;
  border-bottom: 10px solid #eee;
  margin: 0 auto;
}
// サイドバー
.ly_cont_side {
  width: 220px;
  height: 100%;
  background-color:#eee;
  .ly_cont_side_box {
    background-color: #fff;
    width: 210px;
    margin: 0 10px 10px 10px;
    padding: 10px 0 10px 5px;
  }
}
// 商品リスト
.ly_cont_main {
  float: right;
  width: 1020px;
  height: 100%;
  background-color: #eee;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  .ly_cont_main_inner {
    // height: 100%;
    // width: 100%;
    background-color: #eee;
  }
}
// フッター
.ly_footer {
  height: 100px;
  width: 100%;
  max-width: 1240px;
  margin: 0 auto;
  border-top: 1px solid #666;
  h3 {
    text-align: center;
    font-size: 1rem;
    color: #666;
    padding-top: 1rem;
    margin-bottom: 2rem;
  }
  // background-color: blueviolet;
}

// ブロック //

.bl_detail {
  width: 100%;
  min-width: 1240px;
  height: 650px;
  margin: 0 auto;
  position: relative;
  // display: flex;
  // justify-content: center;
  background-color: #eee;
  h5 {
    font-size: 18px;
  }
}

// 詳細ブロック
.bl_detail_dressroom {
  position: relative;
  float: left;
  width: 400px;
  min-width: 400px;
  height: 630px;
  margin: 10px 0 0 10px;
  overflow: hidden;
  background-color: #fff;
  border-radius: 10px;
}

.bl_detail_buttons {
  float: left;
  width: 830px;
  min-width: 830px;
  height: 400px;
  overflow: hidden;
  background-color: #eee;
  .bl_detail_panel {
    float: left;
    width: 400px;
    height: 120px;
    margin: 10px 0 0 10px;
    padding-top: 10px;
    border-radius: 10px;
    background-color: #fff;
  }
}
.bl_detail_info {
  float: left;
  width: 830px;
  min-width: 830px;
  height: 250px;
  overflow: hidden;
  border-top: 1px solid #ddd;
  background-color: #eee;
}
.bl_header_slider {
  width: 180px;
  margin: 24px 0 0 10px;
}
.bl_detail_slider {
  width: 200px;
  margin: 24px 0 0 100px;
}

// 詳細試着室
.detail_left {
  float: left;
  display: flex;
  justify-content: flex-end;
  position: relative;
  width: 100px;
  height: 560px;
  overflow: hidden;
  background-color: white;
  .left-title {
    margin-left: -34px;
  }
}
.detail_right {
  float: right;
  display: flex;
  justify-content: flex-start;
  position: relative;
  width: 60px;
  height: 560px;
  overflow: hidden;
  background-color:white;
}
.detail_center {
  position: absolute;
  width: 400px;
}
.detail_dressroom {
  position: relative;
  margin: 20px 0 0 65px;
  width: 270px;
  height: 580px;
  // background-color: blue;
  .image-box {
    position: absolute;
    margin-top: 0px;
    .image-item {
      position: absolute;
      img {
        position: relative;
        width: 270px;
        height: 540px;
      }
    }
  }
}
.detail_dressroom_slider {
  margin-top: 600px;
  height: 300px;
  // width: 100%;
}




// 比較数字
.compare_wide {
  width: 290px;
}
.compare_narrow {
  width: 210px;
}.compare_panel {
  float: left;
  height: 230px;
  margin: 10px 0 0 10px;
  border-radius: 10px;
  background-color: #fff;
  .compare_title {
    width: 100%;
    height: 50px;
    padding-top: 14px;
    h5 {
      font-size: 16px;;      
      color:#D43790;
    }
    .title_underline {
      border: 1px solid #D43790;
      opacity: 0.5;
      width: 120px;
      margin: -6px auto 0; 
    }
  }
  .compare_main {
    float: right;
    width: 180px;
    height: 180px;
    display: flex;
    justify-content: center;
    overflow: hidden;
    h5 {
    font-size: 14px;
    margin: 4px 0 -16px 0;
    }
  }
  .compare_box {
    float: left;
    width: 48%;
  }
  .compare_colon {
    float: left;
    width: 4%;
  }
  .compare_img {
    float: left;
    margin-left: 25px;
    width: 75px;
    height: 150px;
  }
}

.bl_card_cover {
  width: 670px;
  height: 300px;
  margin: 0 auto;
  padding: 10px;
  background-color: blue;
}


.red { color: red }
.white { color: white;}

// タブ //

// 画面表示タブ
.show_tabs {
  float: left;
  overflow: hidden;
}
.show_tabs li,
.show_tabs label {
  float: left;
  width: 100px;
  padding: 5px 0;
  border: 1px solid #ddd;
  cursor: pointer;
  font-size: 11px;
  transition: .3s;
}
.show_tabs li:not(:first-child),
.show_tabs label:not(:first-of-type) {
  border-left: none;
}
.show_tabs li.show-active,
.show_tabs :checked + label {
  background-color: #aaa;
  border-color: #aaa;
  color: #fff;
  cursor: auto;
}
// 表示順タブ ▲付与
.sort_box {
  float: right;
  height: 20px;
  padding: 0 10px;
}
.sort_txt {
  display: inline-block;
  width: 60px;
  height: 20px;
  margin: 10px 0;
  font-size: 12px;
}
span.sorted.desc::after{
    display: inline-block;
    content: '▼';
}
span.sorted.asc::after{
    display: inline-block;
    content: '▲';
}
// 裾の位置　タブ
.length_tabs {
  margin: 10px 0 0px 10px;
  overflow: hidden;
}
.length_tabs li,
.length_tabs label {
  float: left;
  width: 45px;
  padding: 5px 0;
  border: 1px solid #ddd;
  cursor: pointer;
  font-size: 11px;
  transition: .3s;
}
.length_tabs li:not(:first-child),
.length_tabs label:not(:first-of-type) {
  border-left: none;
}
.length_tabs li.active,
.length_tabs :checked + label {
  background-color: #aaa;
  border-color: #aaa;
  color: #fff;
  cursor: auto;
}
// カラー選択タブ
.color_tabs {
  height: 60px;
  li {
    float: left;
    margin: 6px 0 0 4px;
  }
  img {
    width: 20px;
    height: 20px;
  }
  .color_active {
    img {
      border: 2px solid #aaa;
      border-radius: 3px;
    }
  }
}
// 洋服の種類タブ
.category_tabs {
  height: 36px;
  li {
    float: left;
    margin: 10px 0 0 4px;
  }
  img {
    width: 20px;
    height: 20px;
  }
  .category_active {
    img {
      border: 2px solid #aaa;
      border-radius: 3px;
    }
  }
}


// 試着室
.bl_dressbox {
  margin: 0 auto;
  width: 200px;
  height: 390px;
  position: relative;
  overflow: hidden;
  margin-top: -8px;
}
.measure_left {
  position: absolute;
  height: 400px;
  width: 20px;
  left: 0px;
  background-color: white;
  img {
    position: relative;
    width: 36px;
    height: 360px;
  }
}
.measure_right {
  position: absolute;
  height: 400px;
  width: 20px;
  left: 170px;
  background-color: white;
  img {
    position: relative;
    width: 36px;
    height: 360px;
  }
}
.bl_dressroom_1 {
  position: absolute;
  width: 200px;
  height: 400px;
  // background-color: blue;
  .image-box {
    position: absolute;
    margin-top: 0px;
    list-style:  none;
    .image-item {
      position: absolute;
      img {
        position: relative;
        margin-left: 10px;
        width: 180px;
        height: 360px;
      }
    }
  }
}

// カード
.bl_card {
  float: left;
  position: relative;
  width: 240px;
  height: 280px;
  margin: 0 0 10px 10px;
  background-color: white;
  .bl_card_top {
    height: 160px;
    // background-color: blue;;
  }
  .bl_card_img {
    float: left;
    position: relative;
    margin: 5px 0 0 5px;
    width: 150px;
    height: 150px;
    // background-color: red;
    img {
      width: 150px;
      height: 150px;
      border-right: 1px solid #eee;
      object-fit: contain;
    }
  }
  // カード試着室
  .bl_dressroom {
    position: relative;
    float: right;
    margin: 15px 5px 0 0;
    // margin: 0 auto;
    width: 75px;
    height: 150px;
    background-color: white;
    .image-box {
      position: absolute;
      margin-top: 0px;
      list-style:  none;
      .image-item {
        position: absolute;
        img {
          position: relative;
          // margin-left: 10px;
          width: 75px;
          height: 150px;
        }
      }
    }
  }
  .bl_card_text {
    position: relative;
    padding: 10px 20px 0px 20px;
    text-align: left;
    background-color: white;
    p:nth-child(1) {
      height: 38px;
      overflow: hidden;
      font-size: 0.8em;
      margin-bottom: 0px;
    }
    // brand
    p:nth-child(2) {
      width: 150px;
      overflow: hidden;
      font-size: 0.7em;
      font-weight: bold;
      margin-bottom: 0px;
    }
    // shop
    p:nth-child(3) {
      width: 130px;
      height: 15px;
      overflow: hidden;
      font-size: 0.6em;
      margin-bottom: 0px;
    }
    // length
    p:nth-child(4) {
      font-size: 0.6em;
      margin-bottom: 0px;
    }
    // price
    p:nth-child(5) {
      font-size: 0.6em;
      // text-align: right;
    }
  }
}

.bl_card_2 {
  float: left;
  position: relative;
  width: 190px;
  height: 280px;
  margin: 0 0 10px 10px;
  overflow: hidden;
  background-color:white;
}
.bl_card_2_1 {
  width: 100%;
  height: 100%;
  position: absolute;
  .bl_card_img_2 {
    position: relative;
    padding: 10px 0 4px 0;
    img {
      width: 180px;
      height: 180px;
      object-fit: contain;
    }
  }
  .bl_card_text_2 {
    position: relative;
    padding: 0px 20px 0 20px;
    text-align: left;
    background-color: white;
    p:nth-child(1) {
      height: 38px;
      overflow: hidden;
      font-size: 0.8em;
      margin-bottom: 0px;
    }
    // brand
    p:nth-child(2) {
      width: 150px;
      overflow: hidden;
      font-size: 0.7em;
      font-weight: bold;
      margin-bottom: 0px;
    }
    // shop
    p:nth-child(3) {
      width: 130px;
      height: 15px;
      overflow: hidden;
      font-size: 0.6em;
      margin-bottom: 0px;
    }
    // length
    p:nth-child(4) {
      font-size: 0.6em;
      margin-bottom: -15px;
      // text-align: left;
    }
    // price
    p:nth-child(5) {
      font-size: 0.6em;
      text-align: right;
      margin-bottom: -15px;
    }
  }
}
.bl_card_2_1:last-child {
  top: 100%;
  background-color: white;
  transition: 0s;

}
.bl_card_2:hover {
  .bl_card_2_1:last-child {
    top: 0;
  }
}
.bl_dressroom_3 {
  position: relative;
  margin: 0 auto;
  margin-left: 35px;
  text-align: center;
  .image-box {
    position: absolute;
    margin-top: -240px;
    list-style:  none;
    .image-item {
      position: absolute;
      img {
        position: relative;
        margin-top: -240px;
        width: 120px;
        height: 240px;
      }
    }
  }
}
.bl_card_text_3 {
  position: relative;
  margin-top: 250px;
  // padding: 0px 20px 0 20px;
  text-align: left;
  // background-color: blue;
  p:nth-child(1) {
    width: 150px;
    overflow: hidden;
    font-size: 0.7em;
    font-weight: bold;
    margin-bottom: 0px;
  }
      // length
  p:nth-child(2) {
    font-size: 0.6em;
    margin-bottom: 0px;
  }
}

.large-select-panel {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  height: 70px;
  padding: 10px 30px;
  img {
    width: 50px;
    height: 50px;
    border-radius: 10px;
    border: 1px solid #ccc;
    object-fit: contain;
    background-color: #fff;
    &:hover {
      border: 2px solid #f0f;
    }
  }
  h5 { 
    margin-top: 4px;
    font-size: 12px;
  }
  .size-item {
    position: relative;
    p {
      margin: -36px 0 0 0;
    }
  }
}

.color-active, .mannequin-active, .size-active, .shoes-active {
  img {
    border: 2px solid #f0f;
    border-radius: 10px;
  }
}

.measure-wrap {
  position: absolute;
  img {
    width: 54px;
  }
}

.txt_highlight {
  color: #D43790;
}
.txt_gray {
  margin-top: -6px;
  color: #666;
}
.slider_txt {
  margin-bottom: -4px;
}
.detail_slider_txt {
  margin: 20px 0 20px 0;
}
.hero img {
  max-width: 1240px;
  width: 100%;
  object-fit: contain;
}
.underline {
  width: 300px;
  height: 1px;
  background-color: #D43790;
  margin: 0 auto;
}
.w50 {
  width: 50%;
  min-height: 100px;
  padding: 1rem;
  // border: 1px solid #ccc;
  img {
  max-width: 300px;
  }
  h4 {
    color:#D43790;
  }
}
.w50_txt {
  width: 50%;
  height: 20px;
  margin-bottom: 30px;
}
.w50_w {
  width: 50%;
  min-height: 100px;
  padding: 1rem;
  // border: 1px solid #ccc;
  img {
  max-width: 450px;
  }
}
.w300 {
  margin: 0 auto;
	width: 240px;
	text-align: left;
  a, p {
    font-size:18px;
  }
  h5 {
    font-size: 12px;
    color: #666;
    margin-top: -6px;
  }
}
</style>